<template>
  <page>
    <div class="main-ct">
      <div class="control-ct">
        <table>
          <tbody>
            <tr>
              <th class="sport-event-label">
                {{
                  $t(
                    'Integrations_Sportradar_Live_Activities_Testing_Tool_Sport_Event'
                  )
                }}
              </th>
              <td class="sport-event-name" @click="copyToClipboard">
                {{ sportEventName }}
              </td>
              <td
                style="cursor: pointer"
                class="sport-event-name"
                @click="copyToClipboard"
              >
                <i class="el-icon-copy-document"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <el-button @click="getReplayFeedAction" type="primary">
          {{ getReplayFeedBtnLabel }}
        </el-button>
      </div>
      <div class="additional-data-ct">
        <div style="display: flex">
          <el-checkbox
            v-model="formData.payload.event.home_team_possesses"
            :label="
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Home_Team_Possess'
              )
            "
            :disabled="readOnly"
          />
          <el-checkbox
            v-model="formData.payload.event.away_team_possesses"
            :label="
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Away_Team_Possess'
              )
            "
            :disabled="readOnly"
          />
        </div>
        <div style="display:flex; align-items:center; gap:10px">
          <span>{{
            $t(
              'Integrations_Sportradar_Live_Activities_Testing_Tool_Current_Quarter'
            )
          }}</span>
          <el-input-number
            v-model="formData.payload.game.quarter"
            :min="1"
            :max="4"
            size="medium"
            :disabled="readOnly"
          />
        </div>
        <div style="display: flex; align-items: center; gap:10px">
          <span style="display: inline-block; width: 95px;">
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Time_Left'
              )
            }}
          </span>
          <el-input
            v-model="formData.payload.event.time_left_in_quarter"
            :disabled="readOnly"
          />
        </div>
        <div style="display:flex; align-items:center; gap:10px">
          <span>
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Current_Down'
              )
            }}
          </span>
          <el-input-number
            v-model="formData.payload.event.current_down"
            :min="1"
            :max="4"
            size="medium"
            :disabled="readOnly"
          />
        </div>
      </div>
      <div class="additional-data-ct">
        <div style="display: flex; align-items: center; gap:10px">
          <span>
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Event_Type'
              )
            }}
          </span>
          <el-select v-model="formData.payload.event.type" :disabled="readOnly">
            <el-option
              v-for="eventType in eventTypeOptions"
              :key="eventType.value"
              :value="eventType.value"
            />
          </el-select>
        </div>
        <div style="display: flex; align-items: center; gap:10px">
          <el-checkbox
            :label="
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Live_Game'
              )
            "
            v-model="formData.payload.event.is_live"
            border
            :disabled="readOnly"
          />
        </div>
        <div style="display: flex; align-items: center; gap:10px">
          <span>
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Yards_To_Go_For_First'
              )
            }}
          </span>
          <el-input-number
            v-model="formData.payload.event.yards_to_go_for_first"
            :min="1"
            :max="10"
            size="medium"
            :disabled="readOnly"
          />
        </div>
        <div style="display: flex; align-items: center; gap:10px">
          <span>
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Current_Yard_Line'
              )
            }}
          </span>
          <el-input
            style="width: 110px"
            v-model="formData.payload.event.current_yard_line"
            :disabled="readOnly"
          />
        </div>
      </div>
      <div class="team-ct">
        <div class="score-ct">
          <p style="text-align: center">
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Home_Team_Score'
              )
            }}
          </p>
          <el-input-number
            v-model="formData.payload.event.home_score"
            :controls="false"
            :disabled="readOnly"
          />
        </div>
        <div><h1>-</h1></div>
        <div class="score-ct">
          <p style="text-align: center">
            {{
              $t(
                'Integrations_Sportradar_Live_Activities_Testing_Tool_Away_Team_Score'
              )
            }}
          </p>
          <el-input-number
            v-model="formData.payload.event.away_score"
            :controls="false"
            :disabled="readOnly"
          />
        </div>
      </div>
      <div class="event-ct">
        <p style="text-align: center">
          {{
            $t(
              'Integrations_Sportradar_Live_Activities_Testing_Tool_Description'
            )
          }}
        </p>
        <el-input
          style="width: 500px"
          type="textarea"
          :rows="5"
          v-model="formData.payload.event.description"
          :disabled="readOnly"
        />
      </div>
      <div>
        <el-button :disabled="readOnly" type="primary" @click="onSubmit">
          {{ $t('Integrations_Sportradar_Live_Activities_Testing_Tool_Send') }}
        </el-button>
      </div>
    </div>
  </page>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import Page from '@/common/components/page/Page'
import { NflTestFeed } from '@/modules/integrations/types/sportradar/enum/NflEventTestFeed'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'NflLiveActivityTestToolView',

  components: { Page },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    this.createEvent()

    EventBus.$on('integration-status-changed', status => {
      // When activating the integration the value of status is true
      // and deactivating the value of status is false only create a new test event when activating
      if (status) {
        this.createEvent()
      }
    })
  },

  data() {
    return {
      readOnly: false,
      sportEventName: 'nfl-live-activities-test',
      timeOutIds: [],
      NflTestFeed,
      formData: {
        sport: this.model.params.sport,
        payload: {
          game: {
            quarter: 1
          },
          event: {
            home_score: 0,
            away_score: 0,
            type: 'match_started',
            description: 'Match Started',
            is_live: true,
            home_team_possesses: true,
            away_team_possesses: false,
            time_left_in_quarter: '15:00',
            current_down: 1,
            yards_to_go_for_first: 0,
            current_yard_line: 'NE 10'
          }
        },
        params: this.model.params
      },
      eventTypeOptions: [
        {
          value: 'match_started'
        },
        {
          value: 'period_start'
        },
        {
          value: 'score_change'
        },
        {
          value: 'touchdown'
        },
        {
          value: 'period_end'
        },
        {
          value: 'possession_change'
        },
        {
          value: 'match_ended'
        }
      ]
    }
  },

  methods: {
    onSubmit() {
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `live-activity/test-send`,
          data: this.formData
        })
      ).then(() => {
        this.$notify({
          title: this.$t(
            'Integrations_Sportradar_Live_Activities_Testing_Tool_Sent_Notification'
          ),
          type: 'success',
          duration: 2000
        })
      })
    },

    async copyToClipboard() {
      await navigator.clipboard.writeText(this.sportEventName).then(() => {
        this.$notify({
          title: this.$t(
            'Integrations_Sportradar_Live_Activities_Testing_Tool_Copied_Notification'
          ),
          type: 'success'
        })
      })
    },

    async replayFeed() {
      await this.replayTestFeed()
      this.readOnly = false
    },

    stopReplayingFeed() {
      this.timeOutIds.forEach(id => {
        clearTimeout(id)
      })
      this.timeOutIds = []
      this.readOnly = false
    },

    replayTestFeed() {
      this.readOnly = true
      return new Promise(resolve => {
        this.NflTestFeed.forEach((payload, index) => {
          let timeOutId = setTimeout(() => {
            this.formData.payload = payload
            this.onSubmit()
            if (payload.event.type === 'match_ended') {
              resolve()
            }
          }, index * 2000)
          this.timeOutIds.push(timeOutId)
        })
      })
    },

    createEvent() {
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `live-activity/add-test-event`,
          data: {
            sport: this.model.params.sport
          }
        })
      )
    }
  },

  computed: {
    getReplayFeedAction() {
      return this.readOnly ? this.stopReplayingFeed : this.replayFeed
    },

    getReplayFeedBtnLabel() {
      return this.readOnly
        ? this.$t(
            'Integrations_Sportradar_Live_Activities_Testing_Tool_Stop_Feed'
          )
        : this.$t(
            'Integrations_Sportradar_Live_Activities_Testing_Tool_Replay_Feed'
          )
    }
  },

  watch: {
    'formData.payload.event.home_team_possesses'(newValue) {
      if (newValue && this.formData.payload.event.away_team_possesses) {
        this.formData.payload.event.away_team_possesses = false
      }
    },
    'formData.payload.event.away_team_possesses'(newValue) {
      if (newValue && this.formData.payload.event.home_team_possesses) {
        this.formData.payload.event.home_team_possesses = false
      }
    },
    'formData.payload.event.type'(newValue) {
      if (newValue === 'match_ended' && this.formData.payload.event.is_live) {
        this.formData.payload.event.is_live = false
        return
      }

      if (!this.formData.payload.event.is_live && newValue !== 'match_ended') {
        this.formData.payload.event.is_live = true
      }
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  font-size: 14px;
}
.team-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
}

.event-ct {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
}

.sport-event-label {
  border: 1px solid #ebeef5;
  padding: 12px 10px;
  background: #fafafa;
  color: #909399;
  font-size: 14px;
}

table {
  border-spacing: 0;
}

.sport-event-name {
  border: 1px solid #ebeef5;
  padding: 12px 10px;
  font-size: 14px;
}

.control-ct {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.score-ct {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.additional-data-ct {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 30px;
}

/deep/ .is-checked .el-checkbox__inner {
  background-color: #1d87c8;
  border-color: #1d87c8;
}

/deep/ .el-checkbox.is-bordered.is-checked {
  border-color: #1d87c8;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/sportradar/components/NflLiveActivityTestToolView.vue